import { Component, OnInit } from '@angular/core';
import { ProductsService } from '../../../services/products.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.css']
})
export class CategoriesComponent implements OnInit {
  url: number;
  id: number;
  samecat: any;
  similarcat: any;
  loading: any;
  constructor(private productService: ProductsService, private router: Router, private route: ActivatedRoute) {
    this.route.params.subscribe(params => {
      this.id = +params['id'];
      this.url = +params['url'];
      this.getChildCategory(this.id, this.url);
    });
   }

  ngOnInit() {
  }

  getChildCategory(pcid, pcname) {
    this.loading = true;
    this.productService.getSimilerproduct(pcid)
    .subscribe(
    (x) => {
      this.similarcat = x;
      this.loading = false;
    });
    }

    goToSimilarProduct(id, url) {
      this.productService.getSimilerproduct(id)
      .subscribe(
      (x) => {
        this.samecat = x;
        if (this.samecat && this.samecat.length > 0 && (url === 'Dog' ||
          url === 'Cat' || url === 'Bird' || url === 'Fish' )) {
         this.router.navigate(['/store/categories/', id, url]);
         }  else {
         this.router.navigate(['/store/products/', id, url]);
         }
      });
    }

}
